import { useIntl } from 'react-intl';
import { useMutation, useQueryClient } from '@tanstack/react-query';

import { API } from 'src/reactQuery/Api';
import { putRequest } from 'src/utils/request';
import { QUERY_KEYS } from 'src/reactQuery/QueryKeys';
import messages from 'src/pages/DynamicFieldsPage/messages';
import { RequestSimplifiedData } from 'src/types/requestData';
import { useMessageHandler } from 'src/utils/hooks/useMessageHandler';

import { buildSaveDynamicFieldParams } from './useCreateDynamicField';
import type { DynamicFieldParamsType } from './useCreateDynamicField';

type UpdateDynamicFieldParamsType = DynamicFieldParamsType & {
  dynamicFieldUuid: string;
};

const updateDynamicField = async (
  dynamicField: UpdateDynamicFieldParamsType,
) => {
  const { data } = await putRequest<RequestSimplifiedData>(
    API.PUT.updateDynamicField(dynamicField.dynamicFieldUuid),
    buildSaveDynamicFieldParams(dynamicField),
  );
  return data;
};

export const useUpdateDynamicField = () => {
  const client = useQueryClient();
  const { formatMessage } = useIntl();
  const { handleError, handleSuccess } = useMessageHandler();

  return useMutation({
    mutationFn: updateDynamicField,
    onSuccess: () => {
      handleSuccess(formatMessage(messages.dynamicFieldSaved), 1000);
      client.invalidateQueries({ queryKey: [QUERY_KEYS.DYNAMIC_FIELDS] });
    },
    onError: handleError,
  });
};
